module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"DailyReport":"日報","WeeklyReport":"週報","MonthlyReport":"月報"}}')
  delete Component.options._Ctor
}
